import * as angular from 'angular';
import * as _ from 'lodash';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LineConfigsServiceName, {LineConfigsService, LineItem} from "../../services/lineConfigs/lineConfigs.service";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import {apsEnums} from "../../shared/dto/aps.enums";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import {apsCommands} from "../../shared/dto/aps.commands";
import template from './editLineEquipment.tpl.html';

let requires = [LineConfigsServiceName, UIUtilityServiceName, NewGuidServiceName, LoaderServiceName, NotifyServiceName];

interface EditLineEquipment {
  save(): void;
  close(): void;
  editedLineEquipmentChanged(): void;
  dialogHeaderText: string;
  form: angular.IFormController;
  isNew: boolean;
  equipment: apsViewModels.EquipmentDetail[];
  dataPoints: apsViewModels.DataPointDetail[];
  inspectionDataPoints: apsViewModels.DataPointDetail[];
  rejectDataPoints: apsViewModels.DataPointDetail[];
  alarmDataPoints: apsViewModels.DataPointDetail[];
  editedLineEquipment: apsViewModels.LineEquipmentItem;
  line: LineItem;
  lineEquipmentNames: apsViewModels.LineEquipmentNameItem[];
  filteredEquipment: apsViewModels.EquipmentDetail[];
  dataPointTypes: EnumOption[];
  requiresEquipment: boolean;
  requiresInspect: boolean;
  requiresReject: boolean;
  allowCalculatedInspect: boolean;
  calculatedInspect: boolean;
  allowSubordinateCounts: boolean;
  calculatedInspectChanged(): void;
  inspectionDataPointChanged(): void;
  rejectDataPointChanged(): void;
  lineEquipmentNameChanged(): void;
  equipmentChanged(): void;
  filterDataPoint(filterValue: string): string;
  filteredDataPointLimit(filterValue: string): number;
  addDataPoint(): void;
  detailDataPointChanged(detail: apsViewModels.LineEquipmentDataPointItem): void;
  detailDataPoints(type: apsEnums.DataPointType): apsViewModels.DataPointDetail[];
  detailTypeChanged(detail: apsViewModels.LineEquipmentDataPointItem): void;
  deleteDetail(detail: apsViewModels.LineEquipmentDataPointItem): void;
}

export interface EditLineEquipmentData {
  lineEquipment: apsViewModels.LineEquipmentItem;
  line: LineItem;
  shop: apsViewModels.ShopNavigation;
  lineEquipmentNames: apsViewModels.LineEquipmentNameItem[];
  equipment: apsViewModels.EquipmentDetail[];
  dataPoints: apsViewModels.DataPointDetail[];
}

export function openEditLineEquipment(data: EditLineEquipmentData,
                                      $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'EditLineEquipmentCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

export default angular.module('aps.controller.editLineEquipment', requires)
  .controller('EditLineEquipmentCtrl', editLineEquipmentCtrl)
  .name;

function editLineEquipmentCtrl(
  newGuidService: NewGuidService,
  loaderService: LoaderService,
  notifyService: NotifyService,
  lineConfigsService: LineConfigsService,
  $modalInstance: mm.foundation.modalInstance,
  uiUtilityService: UIUtilityService,
  data: EditLineEquipmentData
): EditLineEquipment {

  let vm = {} as EditLineEquipment;
  vm.requiresEquipment = false;
  vm.requiresInspect = true;
  vm.requiresReject = true;
  vm.allowCalculatedInspect = false;
  vm.calculatedInspect = false;
  vm.allowSubordinateCounts = false;
  vm.dataPointTypes = uiUtilityService.getListOptionsFromEnum(apsEnums.DataPointType, 1);

  function setEligibleDataPoints(type: apsEnums.DataPointType, dataPoints: apsViewModels.DataPointDetail[]) {
    return _.filter(dataPoints, (dp) => {
      return dp.type === type;
    });
  }

  function setDataPointsBasedOnSelectedEquipment() {
    vm.inspectionDataPoints = setEligibleDataPoints(apsEnums.DataPointType.Inspect, vm.dataPoints);
    vm.rejectDataPoints = setEligibleDataPoints(apsEnums.DataPointType.Reject, vm.dataPoints);
    vm.alarmDataPoints = setEligibleDataPoints(apsEnums.DataPointType.Alarm, vm.dataPoints);
  }

  vm.dataPoints = data.dataPoints;
  setDataPointsBasedOnSelectedEquipment();

  vm.lineEquipmentNames = data.lineEquipmentNames;
  vm.equipment = data.equipment;
  vm.dialogHeaderText = 'Add Line Equipment';
  vm.editedLineEquipment = <apsViewModels.LineEquipmentItem>{};
  vm.line = data.line;

  let wsiCalculatedConfig = '{"Calculated":true}';
  let wsiDefaultConfig = '{}';
  let wbfDefaultConfig = '{"MoldIndex":0}';
  let wbfRejectConfig = '{"MoldIndex":2}';

  let heyeDefaultConfig = '{"Active":true}';

  let checkDetectorDefaultConfig = '{}';
  let mX4DefaultConfig = '{}';
  let mcalDefaultConfig = '{}';
  let multiDefaultConfig = '{}';
  let flexInspectDefaultConfig = '{}';
  let defaultConfig = '{}';

  function retrieveDataPointIfFound(isInspection: boolean) {
    let nameToCheck = isInspection
      ? vm.editedLineEquipment.inspectionDataPointName
      : vm.editedLineEquipment.rejectDataPointName;
    let idToCheck = isInspection
      ? vm.editedLineEquipment.inspectionDataPointId
      : vm.editedLineEquipment.rejectDataPointId;
    let dataPoint = _.find(vm.dataPoints, {name: nameToCheck});
    if (!dataPoint) {
      dataPoint = _.find(vm.dataPoints, {id: idToCheck});
      if (!dataPoint) {
        return;
      }
    }
    if (isInspection) {
      if (vm.calculatedInspect) {
        if (dataPoint.config !== wsiCalculatedConfig) {
          vm.calculatedInspect = false;
        }
      }
      vm.editedLineEquipment.inspectionDataPointId = dataPoint.id;
      if (!vm.editedLineEquipment.inspectionDataPointName) {
        vm.editedLineEquipment.inspectionDataPointName = dataPoint.name;
      }
    } else {
      vm.editedLineEquipment.rejectDataPointId = dataPoint.id;
      if (!vm.editedLineEquipment.rejectDataPointName) {
        vm.editedLineEquipment.rejectDataPointName = dataPoint.name;
      }
    }
  }

  vm.inspectionDataPointChanged = () => {
    retrieveDataPointIfFound(true);
  };

  vm.rejectDataPointChanged = () => {
    retrieveDataPointIfFound(false);
  };

  vm.detailDataPointChanged = (detail: apsViewModels.LineEquipmentDataPointItem) => {
    let dataPoint = _.find(vm.dataPoints, {name: detail.dataPointName});
    if (dataPoint) {
      detail.dataPointId = dataPoint.id;
      return;
    }

    detail.dataPointName = '';
    detail.dataPointId = null;
  };

  vm.lineEquipmentNameChanged = () => {
    let lineEquipmentName = _.find(vm.lineEquipmentNames, { id: vm.editedLineEquipment.lineEquipmentNameId });
    let equipmentType = null;
    vm.requiresInspect = true;
    vm.requiresReject = true;
    vm.allowCalculatedInspect = false;
    vm.allowSubordinateCounts = false;
    if (lineEquipmentName) {
      if (lineEquipmentName.type === apsEnums.LineEquipmentType.WSI) {
        equipmentType = apsEnums.EquipmentType.WSI;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.WBF) {
        equipmentType = apsEnums.EquipmentType.WBF;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.HEYE) {
        equipmentType = apsEnums.EquipmentType.HEYE;
        vm.requiresInspect = false;
        vm.requiresReject = false;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.Counter) {
        vm.requiresReject = false;
        vm.allowSubordinateCounts = true;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.Palletizer) {
        vm.requiresReject = false;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.InspectReject) {
        vm.allowSubordinateCounts = true;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.CheckDetector) {
        equipmentType = apsEnums.EquipmentType.CheckDetector;
        vm.requiresInspect = false;
        vm.requiresReject = false;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.MX4) {
        equipmentType = apsEnums.EquipmentType.MX4;
        vm.requiresInspect = true;
        vm.requiresReject = false;
        vm.allowSubordinateCounts = true;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.Multi) {
        equipmentType = apsEnums.EquipmentType.Multi;
        vm.requiresInspect = false;
        vm.requiresReject = false;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.Mcal) {
        equipmentType = apsEnums.EquipmentType.Mcal;
        vm.requiresInspect = false;
        vm.requiresReject = false;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.FlexBC) {
        equipmentType = apsEnums.EquipmentType.FlexBC;
        vm.requiresInspect = true;
        vm.requiresReject = true;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.FlexM) {
        equipmentType = apsEnums.EquipmentType.FlexM;
        vm.requiresInspect = true;
        vm.requiresReject = true;
      } else if (lineEquipmentName.type === apsEnums.LineEquipmentType.FlexIS) {
      equipmentType = apsEnums.EquipmentType.FlexIS;
      vm.requiresInspect = true;
      vm.requiresReject = true;
    }
      vm.editedLineEquipment.name = lineEquipmentName.name;
      vm.editedLineEquipment.type = lineEquipmentName.type;
    } else {
      vm.editedLineEquipment.name = null;
      vm.editedLineEquipment.type = null;
    }
    if (equipmentType) {
      let equipment = _.find(vm.equipment, { id: vm.editedLineEquipment.equipmentId });
      if (equipment && equipment.type !== equipmentType) {
        vm.editedLineEquipment.equipmentId = null;
        equipment = null;
      }
      if (equipment) {
        if (equipment.type === apsEnums.EquipmentType.WSI || equipment.type === apsEnums.EquipmentType.WBF) {
          if (!equipment.isSimulator) {
            vm.allowCalculatedInspect = true;
            let dataPoint = _.find(vm.dataPoints, {id: vm.editedLineEquipment.inspectionDataPointId});
            if (dataPoint && dataPoint.config === wsiCalculatedConfig) {
              vm.calculatedInspect = true;
            }
          }
        }
      }
      vm.requiresEquipment = true;
      vm.filteredEquipment = data.equipment.filter(e => e.type === equipmentType);
    } else {
      vm.editedLineEquipment.equipmentId = null;
      vm.requiresEquipment = false;
      vm.filteredEquipment = [];
    }
    if (!vm.editedLineEquipment.detailDataPoints
      || (!vm.allowSubordinateCounts 
          && vm.editedLineEquipment.detailDataPoints.length > 0)) {
      vm.editedLineEquipment.detailDataPoints = [];
    }
  };

  function setWsiInspectDataPoint(equipment: apsViewModels.EquipmentDetail) {
    let inspectDataPoint = _.find(equipment.dataPoints, {
      type: apsEnums.DataPointType.Inspect,
      config: vm.calculatedInspect ? wsiCalculatedConfig
        : (equipment.type === apsEnums.EquipmentType.WBF ? wbfDefaultConfig : wsiDefaultConfig)
    });
    if (inspectDataPoint) {
      vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
      vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
    }
  }

  function setWsiDataPoints(equipment: apsViewModels.EquipmentDetail) {
    if (!equipment.isSimulator) {
      vm.allowCalculatedInspect = true;
    }
    setWsiInspectDataPoint(equipment);
    let rejectConfig = wsiDefaultConfig;
    if (equipment.type === apsEnums.EquipmentType.WBF) {
      rejectConfig = wbfRejectConfig;
    }
    let rejectDataPoint = _.find(equipment.dataPoints, {type: apsEnums.DataPointType.Reject, config: rejectConfig});
    if (rejectDataPoint) {
      vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
      vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
    }
  }

  function setHeyeDataPoints(equipment: apsViewModels.EquipmentDetail) {
    let inspectDataPoint = _.find(equipment.dataPoints, {type: apsEnums.DataPointType.Inspect, config: heyeDefaultConfig});
    if (inspectDataPoint) {
      vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
      vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
    }
    let rejectDataPoint = _.find(equipment.dataPoints, {type: apsEnums.DataPointType.Reject, config: heyeDefaultConfig});
    if (rejectDataPoint) {
      vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
      vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
    }
  }

  function setCheckDetectorDataPoints(equipment: apsViewModels.EquipmentDetail) {
    let inspectFilter = {type: apsEnums.DataPointType.Inspect, config: checkDetectorDefaultConfig};
    let inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
    if (inspectDataPoint) {
      vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
      vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
    }
    let rejectFilter = {type: apsEnums.DataPointType.Reject, config: checkDetectorDefaultConfig};
    let rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
    if (rejectDataPoint) {
      vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
      vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
    }
  }
 
  function setMX4DataPoints(equipment: apsViewModels.EquipmentDetail) {
    let inspectFilter = {type: apsEnums.DataPointType.Inspect, config: mX4DefaultConfig};
    let inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
    if (inspectDataPoint) {
      vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
      vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
    }
    let rejectFilter = {type: apsEnums.DataPointType.Reject, config: mX4DefaultConfig};
    let rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
    if (rejectDataPoint) {
      vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
      vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
    }
  }
  function setMcalDataPoints(equipment: apsViewModels.EquipmentDetail) {
    let inspectFilter = {type: apsEnums.DataPointType.Inspect, config: mcalDefaultConfig};
    let inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
    if (inspectDataPoint) {
      vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
      vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
    }
    let rejectFilter = {type: apsEnums.DataPointType.Reject, config: mcalDefaultConfig};
    let rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
    if (rejectDataPoint) {
      vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
      vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
    }
  }
  function setMultiDataPoints(equipment: apsViewModels.EquipmentDetail) {
    let inspectFilter = {type: apsEnums.DataPointType.Inspect, config: multiDefaultConfig};
    let inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
    if (inspectDataPoint) {
      vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
      vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
    }
    let rejectFilter = {type: apsEnums.DataPointType.Reject, config: multiDefaultConfig};
    let rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
    if (rejectDataPoint) {
      vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
      vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
    }
  }  
  
  function setFlexInspectDataPoints(equipment: apsViewModels.EquipmentDetail) {
    let inspectFilter = {type: apsEnums.DataPointType.Inspect, config: flexInspectDefaultConfig};
    let inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
    if (inspectDataPoint) {
      vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
      vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
    }
    let rejectFilter = {type: apsEnums.DataPointType.Reject, config: flexInspectDefaultConfig};
    let rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
    if (rejectDataPoint) {
      vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
      vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
    }
  }

  function setInspectDataPoints(equipment: apsViewModels.EquipmentDetail, defaultConfiguration) {
    let inspectFilter = {type: apsEnums.DataPointType.Inspect, config: defaultConfiguration};
    let inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
    if (inspectDataPoint) {
      vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
      vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
    }
    let rejectFilter = {type: apsEnums.DataPointType.Reject, config: defaultConfiguration};
    let rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
    if (rejectDataPoint) {
      vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
      vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
    }
  }



  vm.equipmentChanged = () => {
    vm.allowCalculatedInspect = false;
    let equipment = _.find(vm.equipment, { id: vm.editedLineEquipment.equipmentId });
    if (equipment) {
      if (equipment.type === apsEnums.EquipmentType.WSI || equipment.type === apsEnums.EquipmentType.WBF) {
        setWsiDataPoints(equipment);
      } else if (equipment.type === apsEnums.EquipmentType.HEYE) {
        setHeyeDataPoints(equipment);
      } else if (equipment.type === apsEnums.EquipmentType.CheckDetector) {
        setCheckDetectorDataPoints(equipment);
      } else if (equipment.type === apsEnums.EquipmentType.MX4) {
        setMX4DataPoints(equipment);
      } else if (equipment.type === apsEnums.EquipmentType.Mcal) {
        setMcalDataPoints(equipment);
      } else if (equipment.type === apsEnums.EquipmentType.Multi) {
        setMultiDataPoints(equipment);
      } else if (equipment.type === apsEnums.EquipmentType.FlexBC || equipment.type === apsEnums.EquipmentType.FlexM) {
        setFlexInspectDataPoints(equipment);
      }
      else if (equipment.type === apsEnums.EquipmentType.FlexIS)
      {
        setInspectDataPoints(equipment, defaultConfig);
      }
    }
  };

  vm.calculatedInspectChanged = () => {
    let equipment = _.find(vm.equipment, { id: vm.editedLineEquipment.equipmentId });
    if (equipment && (equipment.type === apsEnums.EquipmentType.WSI
      || equipment.type === apsEnums.EquipmentType.WBF)) {
      setWsiInspectDataPoint(equipment);
    }
  };

  let showAll = (filterValue: string) => {
    let fv = filterValue.toLocaleLowerCase();
    return _.findIndex(['al', 'all'], function (o) { return o === fv; }) > -1;
  };

  vm.filterDataPoint = (filterValue) => {
    return showAll(filterValue) ? null : filterValue;
  };

  vm.filteredDataPointLimit = (filterValue) => {
    return showAll(filterValue) ? null : 8;
  };

  if (data.lineEquipment) {
    vm.dialogHeaderText = 'Edit Line Equipment';
    vm.isNew = false;

    let details = [];
    data.lineEquipment.detailDataPoints.forEach(detail =>
      details.push(_.assign({}, detail)));
    _.assign(vm.editedLineEquipment, data.lineEquipment);
    vm.editedLineEquipment.detailDataPoints = details;
    vm.inspectionDataPointChanged();
    vm.rejectDataPointChanged();
    vm.lineEquipmentNameChanged();
  } else {
    let lineOrderMax: number = 0;

    if (vm.line) {
      if (vm.line && vm.line.equipment) {
        vm.line.equipment.forEach(equipmentItem => {
          if (equipmentItem.order > lineOrderMax) {
            lineOrderMax = equipmentItem.order;
          }
        });
      }

      vm.editedLineEquipment.lineId = data.line.id;
    }

    newGuidService.getNewGuid('lineEquipment').then(id => vm.editedLineEquipment.id = id.toString());
    vm.editedLineEquipment.shopId = data.shop.id;
    vm.editedLineEquipment.order = lineOrderMax + 1;
    vm.isNew = true;
  }

  vm.save = () => {
    if (vm.form.$invalid) {
      return;
    }

    let command: apsCommands.LineEquipmentBase = {
      id: vm.editedLineEquipment.id,
      shopId: vm.editedLineEquipment.shopId,
      equipmentId: vm.editedLineEquipment.equipmentId,
      inspectionDataPointId: vm.editedLineEquipment.inspectionDataPointId,
      lineEquipmentNameId: vm.editedLineEquipment.lineEquipmentNameId,
      lineId: vm.editedLineEquipment.lineId,
      rejectDataPointId: vm.editedLineEquipment.rejectDataPointId,
      detailDataPoints: vm.editedLineEquipment.detailDataPoints
    };

    let promise = vm.isNew
      ? lineConfigsService.addLineEquipment(command)
      : lineConfigsService.updateLineEquipment(command);

    loaderService.loadingPromise(promise.then(() => {
      $modalInstance.close(vm.editedLineEquipment);
    }, notifyService.handleApiErrors));
  };

  vm.close = () => {
    $modalInstance.close();
  };

  vm.addDataPoint = (): void => {
    if (!vm.allowSubordinateCounts) {
      return;
    }

    if (!vm.editedLineEquipment.detailDataPoints) {
      vm.editedLineEquipment.detailDataPoints = [];
    }

    let dataPoint = {
      lineId: vm.editedLineEquipment.lineId,
      shopId: vm.editedLineEquipment.shopId,
      lineEquipmentId: vm.editedLineEquipment.id,
      dataPointId: null,
      dataPointName: '',
      type: vm.editedLineEquipment.type === apsEnums.LineEquipmentType.InspectReject
        ? apsEnums.DataPointType.Reject : apsEnums.DataPointType.Inspect,
      order: vm.editedLineEquipment.detailDataPoints.length,
      id: null,
      name: ''
    };
    newGuidService.getNewGuid('lineEquipmentDataPoint').then(id => dataPoint.id = id);
    vm.editedLineEquipment.detailDataPoints.push(dataPoint);
  };

  vm.detailDataPoints = (type: apsEnums.DataPointType) => {
    switch (type) {
      case apsEnums.DataPointType.Inspect:
        return vm.inspectionDataPoints;
      case apsEnums.DataPointType.Reject:
        return vm.rejectDataPoints;
      case apsEnums.DataPointType.Alarm:
        return vm.alarmDataPoints;
    }
    return vm.dataPoints;
  };

  vm.detailTypeChanged = (detail: apsViewModels.LineEquipmentDataPointItem) => {
    if (!detail.dataPointId) {
      return;
    }

    let dataPoint = _.find(vm.dataPoints, {id: detail.dataPointId});
    if (dataPoint.type !== detail.type) {
      detail.dataPointId = null;
      detail.dataPointName = '';
    }
  };

  vm.deleteDetail = (detail: apsViewModels.LineEquipmentDataPointItem) => {
    _.remove(vm.editedLineEquipment.detailDataPoints, detail);
  };

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/lineConfigs/editLineEquipment.controller.ts